<template>
    <v-container grid-list-md fluid>
        <v-card class="default_card large mx-0 my-2 pa-2 fill-height sticky-card" elevation="0">
            <v-row class="py-1" style="flex-wrap: nowrap">
                <v-col class="d-flex headline align-center" cols="9">
                    <v-btn-back @click.stop="$router.go(-1)"> </v-btn-back>
                    <v-text-field-filled
                        v-model="title"
                        label="Le titre de votre tableau personnalisé"
                        :rules="[rules.notEmpty]"
                        hide-details
                        single-line
                        class="pl-1"
                        outlined
                        :readonly="readOnly"
                        density="compact"
                    />
                    <!-- </v-col>
                <v-col class="d-flex headline align-center flex-grow-0 flex-shrink-1" cols="2"> -->
                    <v-select-filled
                        outlined
                        v-model="use"
                        :items="uses"
                        label="Usage"
                        class="pl-1"
                        hide-details
                        density="compact"
                    />
                    <!-- </v-col>

                <v-col cols="2" class="d-flex align-center flex-grow-1 flex-shrink-0"> -->
                    <v-combobox-filled
                        v-model="range"
                        label="Définissez la portée"
                        class="pl-1"
                        multiple
                        chips
                        closable
                        hide-details
                        item-disabled
                        :rules="[rules.onlyNumbers]"
                        :readonly="readOnly"
                    />

                    <v-select-filled
                        v-model="type"
                        :items="types"
                        label="Type"
                        class="pl-1 d-flex flex-grow-0 flex-shrink-1"
                        hide-details
                        v-if="type !== 'BALANCE_SHEET'"
                        density="compact"
                    />
                    <v-text-field-filled
                        label="Type"
                        hide-details
                        single-line
                        class="pl-1 d-flex flex-grow-1 flex-shrink-0"
                        readonly
                        v-else
                        :model-value="'Bilan'"
                        density="compact"
                    />
                </v-col>
                <!-- <v-col class="flex-grow-0 flex-shrink-1"></v-col> -->
                <v-col class="d-flex justify-end align-center">
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$oss-duplicate"
                                class="elevation-0 mr-3"
                                color="secondary"
                                v-bind="props"
                                :disabled="type === 'BALANCE_SHEET'"
                                @click="duplicate"
                                size="small"
                            />
                        </template>
                        <span>Dupliquer</span>
                    </v-tooltip>
                    <v-tooltip :disabled="!disabledTable" location="bottom">
                        <template v-slot:activator="{ props }">
                            <div v-bind="props">
                                <v-btn
                                    rounded
                                    elevation="0"
                                    class="ml-0"
                                    :disabled="disabledTable"
                                    @click="dialogTab = true"
                                    size="small"
                                >
                                    Tableau
                                </v-btn>
                            </div>
                        </template>
                        <span> Définissez une portée pour voir les comptes non utilisés</span>
                    </v-tooltip>
                    <v-btn
                        rounded
                        elevation="0"
                        class="ml-2"
                        :disabled="isDisabled || readOnly"
                        @click="upsertOperatingAccount(false)"
                        size="small"
                    >
                        {{ this.idSheet === null ? "Créer" : " Sauver " }}
                    </v-btn>
                    <v-btn
                        rounded
                        elevation="0"
                        class="ml-2"
                        :disabled="!isFinished || readOnly || !!!scopeId"
                        @click="upsertOperatingAccount(true)"
                        size="small"
                    >
                        Valider
                    </v-btn>
                </v-col>
            </v-row>
            <!-- <v-row no-gutters>  // not necessary since 03/2024 => now validation from rootProfile is automaticcally done for allComp (search forAllCom... = true to understand)
                <v-col cols="12" class="d-flex justify-end" v-if="isRootProfile">
                    <v-btn
                        rounded
                         size="small"
                        color="secondary"
                        elevation="0"
                        class="mr-3"
                        :disabled="!isFinished"
                        @click="validationBobby()"
                        v-if="(scopeSharingStatus==='PENDING_VALIDATION' || scopeSharingStatus==='EDITION') && isRootProfile"
                    >
                        Rendre visible pour tous
                    </v-btn>
                    <v-btn
                        rounded
                         size="small"
                        color="secondary"
                        elevation="0"
                        class="mr-3"
                        @click="devalidationBobby()"
                        v-if="scopeSharingStatus==='VALIDATE' && allAccountingCompany && isRootProfile"
                    >
                        Enlever pour tous (sauf créateur)
                    </v-btn>
                </v-col>
            </v-row> -->
        </v-card>
        <v-card elevation="0" :style="'max-height:' + maxHeight + ';' + 'overflow:auto'">
            <v-row no-gutters class="d-flex" v-if="OutOfPCF">
                <v-col>
                    <v-icon size="x-small" color="error">$fa-exclamation-triangle</v-icon>
                    Attention certaines lignes débordent du plan comptable (enlever les nombres en
                    rouge)
                </v-col>
            </v-row>
            <v-row
                no-gutters
                class="d-flex"
                v-if="
                    AArestants.length !== 0 &&
                    range.length !== 0 &&
                    accountableAccountsUsed.length !== 0
                "
            >
                <v-col>
                    <v-icon size="x-small" color="orange">$fa-exclamation-triangle</v-icon>
                    Attention certains comptes comptables de la portée n'ont pas été rentrés
                    (cliquer sur TABLEAU, en haut à droite)
                </v-col>
            </v-row>
            <v-row
                no-gutters
                class="d-flex"
                v-if="doublons.length !== 0 && accountableAccountsUsed.length !== 0"
            >
                <v-col>
                    <v-icon size="x-small" color="orange">$fa-exclamation-triangle</v-icon>
                    Attention certains comptes comptables sont présents plusieurs fois (chercher les
                    nombres en orange)
                </v-col>
            </v-row>
            <!-- <v-row no-gutters class="d-flex" v-if="errorRatioKey">
                <v-col>
                    <v-icon  size=“x-small” color="orange">$fa-exclamation-triangle</v-icon>
                    Attention certains ratios contiennent des lignes supprimées
                </v-col>
            </v-row> -->
            <v-row class="d-flex py-1" v-if="OA_Tables.length">
                <v-col cols="12" v-for="(table, ti) of OA_Tables" :key="ti + '_Tables'">
                    <h1 class="ml-2" v-if="OA_Tables.length > 1">{{ table.name }}</h1>
                    <v-data-table
                        :headers="headers(table)"
                        :items="table.rows"
                        :items-per-page="-1"
                        hide-default-footer
                        class="table"
                    >
                        <template v-slot:item="props">
                            <tr :key="props.item.index" v-if="props.item.name">
                                <td width="10%">
                                    <v-btn-icon
                                        icon="$fa-angle-up"
                                        class="justify-start"
                                        size="x-small"
                                        color="secondary"
                                        elevation="0"
                                        @click="swapRow2(props.index, props.index - 1, ti)"
                                        v-if="props.index != 0"
                                        :disabled="readOnly"
                                    />
                                    <v-btn-icon
                                        icon="$fa-angle-down"
                                        class="justify-end"
                                        size="x-small"
                                        color="secondary"
                                        elevation="0"
                                        @click="swapRow2(props.index, props.index + 1, ti)"
                                        v-if="props.index !== table.rows.length - 1"
                                        :disabled="readOnly"
                                    />
                                </td>
                                <td>
                                    {{ props.item.name }}
                                </td>
                                <template v-if="!props.item.marginRatio">
                                    <td
                                        v-for="(col, ci) of tableColumns(table)"
                                        :key="ci + '_Column'"
                                    >
                                        <template
                                            v-if="
                                                props.item.columns && props.item.columns[col.value]
                                            "
                                        >
                                            <span
                                                v-for="(condition, i) of props.item.columns[
                                                    col.value
                                                ]"
                                                :key="i + '_Condition'"
                                            >
                                                <template v-if="condition.startsWith">
                                                    <span
                                                        v-for="(
                                                            accountableAccount, i
                                                        ) of condition.startsWith"
                                                        :key="i + '_Numbers'"
                                                    >
                                                        <v-tooltip location="bottom">
                                                            <template v-slot:activator="{ props }">
                                                                <v-chip
                                                                    color="secondary"
                                                                    class="mx-1"
                                                                    v-if="
                                                                        !scopedAccountableAccounts ||
                                                                        !scopedAccountableAccounts.length
                                                                    "
                                                                    v-bind="props"
                                                                    size="small"
                                                                >
                                                                    {{
                                                                        displayVChip(
                                                                            accountableAccount,
                                                                        )
                                                                    }}
                                                                </v-chip>
                                                                <v-chip
                                                                    color="error"
                                                                    class="mx-1"
                                                                    v-else-if="
                                                                        checkNumberAAconcerned(
                                                                            accountableAccount,
                                                                        ) === 0
                                                                    "
                                                                    v-bind="props"
                                                                    size="small"
                                                                >
                                                                    {{
                                                                        displayVChip(
                                                                            accountableAccount,
                                                                        )
                                                                    }}
                                                                </v-chip>
                                                                <v-chip
                                                                    color="error"
                                                                    class="mx-1"
                                                                    v-else-if="
                                                                        isOverflowRange(
                                                                            accountableAccount,
                                                                        )
                                                                    "
                                                                    v-bind="props"
                                                                    size="small"
                                                                >
                                                                    {{
                                                                        displayVChip(
                                                                            accountableAccount,
                                                                        )
                                                                    }}
                                                                </v-chip>
                                                                <v-chip
                                                                    color="orange"
                                                                    class="mx-1"
                                                                    v-else-if="
                                                                        isDoublon(
                                                                            accountableAccount,
                                                                        )
                                                                    "
                                                                    v-bind="props"
                                                                    size="small"
                                                                >
                                                                    {{
                                                                        displayVChip(
                                                                            accountableAccount,
                                                                        )
                                                                    }}
                                                                </v-chip>
                                                                <v-chip
                                                                    color="secondary"
                                                                    class="mx-1"
                                                                    v-else
                                                                    v-bind="props"
                                                                    size="small"
                                                                >
                                                                    {{
                                                                        displayVChip(
                                                                            accountableAccount,
                                                                        )
                                                                    }}
                                                                </v-chip>
                                                            </template>
                                                            <span
                                                                v-if="
                                                                    isOverflowRange(
                                                                        accountableAccount,
                                                                    ) &&
                                                                    checkNumberAAconcerned(
                                                                        accountableAccount,
                                                                    ) !== 0
                                                                "
                                                                >Ce compte déborde de la portée.
                                                            </span>
                                                            <span
                                                                v-else-if="
                                                                    isDoublon(accountableAccount)
                                                                "
                                                                >Comprend des comptes présents en
                                                                double.
                                                            </span>
                                                            <span
                                                                >Nombre de comptes concernés :
                                                                {{
                                                                    checkNumberAAconcerned(
                                                                        accountableAccount,
                                                                    )
                                                                }}</span
                                                            >
                                                        </v-tooltip>
                                                    </span>
                                                </template>
                                                <template v-if="condition.notStartsWith">
                                                    <span
                                                        v-for="(
                                                            notStartsWith, i
                                                        ) in condition.notStartsWith"
                                                        :key="i + '_notStartsWith'"
                                                    >
                                                        <v-tooltip location="bottom">
                                                            <template v-slot:activator="{ props }">
                                                                <v-chip
                                                                    color="primary"
                                                                    class="mr-1"
                                                                    v-bind="props"
                                                                    size="small"
                                                                >
                                                                    {{
                                                                        displayVChip(notStartsWith)
                                                                    }}
                                                                </v-chip>
                                                            </template>
                                                            <span
                                                                >Nombre de comptes concernés :
                                                                {{
                                                                    checkNumberAAconcerned(
                                                                        notStartsWith,
                                                                    )
                                                                }}</span
                                                            >
                                                        </v-tooltip>
                                                    </span>
                                                </template>
                                            </span>
                                        </template>
                                    </td>
                                </template>
                                <td v-else>
                                    {{
                                        "( " +
                                        findTitle(props.item.input.key1) +
                                        " / " +
                                        findTitle(props.item.input.key2) +
                                        " )"
                                    }}
                                </td>
                                <td width="5%">
                                    <v-btn-icon
                                        icon="$oss-edit"
                                        class="justify-end"
                                        color="secondary"
                                        elevation="0"
                                        @click="editRow2(props.index, ti)"
                                        :disabled="readOnly"
                                        size="x-small"
                                    />
                                </td>
                                <td width="5%">
                                    <v-btn-trash
                                        class="justify-end"
                                        size="x-small"
                                        @click="removeRow2(props.index, ti)"
                                        :disabled="readOnly"
                                    />
                                </td>
                            </tr>
                            <tr
                                :key="props.item.index + '_title'"
                                style="background-color: rgb(230, 230, 230)"
                                v-else
                            >
                                <td width="10%">
                                    <v-btn-icon
                                        icon="$fa-angle-up"
                                        class="justify-start"
                                        size="x-small"
                                        color="secondary"
                                        elevation="0"
                                        @click="swapRow2(props.index, props.index - 1, ti)"
                                        v-if="props.index != 0"
                                        :disabled="readOnly"
                                    />
                                    <v-btn-icon
                                        icon="$fa-angle-down"
                                        class="justify-end"
                                        size="x-small"
                                        color="secondary"
                                        elevation="0"
                                        @click="swapRow2(props.index, props.index + 1, ti)"
                                        v-if="props.index !== table.rows.length - 1"
                                        :disabled="readOnly"
                                    />
                                </td>
                                <td
                                    :colspan="tableColumns(table).length + 1"
                                    style="font-weight: bold"
                                >
                                    {{ props.item.title }}
                                </td>
                                <td width="5%">
                                    <v-btn-icon
                                        icon="$oss-edit"
                                        class="justify-end"
                                        color="secondary"
                                        elevation="0"
                                        @click="editTotal2(props.index, ti)"
                                        :disabled="readOnly"
                                        size="x-small"
                                    />
                                </td>
                                <td width="5%">
                                    <v-btn-trash
                                        class="justify-end"
                                        size="x-small"
                                        @click="removeRow2(props.index, ti)"
                                        :disabled="readOnly"
                                    />
                                </td>
                            </tr>
                        </template>
                        <template v-slot:body.append v-if="type !== 'BALANCE_SHEET'">
                            <tr>
                                <td colspan="6" style="text-align: center">
                                    <v-btn
                                        size="small"
                                        elevation="0"
                                        class="ml-4"
                                        @click="
                                            edit = false;
                                            dialogAddOrEditRow = true;
                                        "
                                        :disabled="readOnly"
                                    >
                                        <v-icon size="large" left class="pr-2">$fa-plus</v-icon>
                                        Ajouter
                                    </v-btn>
                                    <v-btn
                                        size="small"
                                        elevation="0"
                                        class="ml-4"
                                        @click="
                                            edit = false;
                                            dialogChooseSig = true;
                                        "
                                        :disabled="readOnly"
                                    >
                                        <v-icon size="large" left class="pr-2">$fa-plus</v-icon>
                                        Solde Intermédiaire
                                    </v-btn>
                                    <v-btn
                                        size="small"
                                        elevation="0"
                                        class="ml-4"
                                        @click="
                                            edit = false;
                                            dialogAddTotal = true;
                                        "
                                        :disabled="readOnly"
                                    >
                                        <v-icon size="large" left class="pr-2">$fa-plus</v-icon>
                                        Total
                                    </v-btn>
                                    <v-btn
                                        size="small"
                                        elevation="0"
                                        class="ml-4"
                                        @click="
                                            edit = false;
                                            dialogAddRatio = true;
                                        "
                                        :disabled="readOnly"
                                    >
                                        <v-icon size="large" left class="pr-2">$fa-plus</v-icon>
                                        Taux
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card>
        <ScopeManager
            ref="scopeManager"
            v-model="scopeSync"
            v-model:id="scopeId"
            v-model:name="scopeName"
            :readonly="readOnly"
        />
        <oss-dialog
            v-model="dialogAddOrEditRow"
            :title="edit ? 'Modifier la ligne' : 'Ajouter une ligne'"
        >
            <div style="width: 85vw">
                <v-form v-model="isValid">
                    <!-- <oss-dialog :actions="CI_creatorActions" v-model="dialogAddOrEditRow" :title="edit ? 'Modifier la ligne' : 'Ajouter une ligne'">
            <template v-slot:content> -->
                    <v-row no-gutters>
                        <v-col cols="11" class="title px-3 pt-2"> Nom de la ligne </v-col>
                        <v-col cols="11" class="d-flex justify-center align-top mx-2">
                            <v-text-field-filled
                                v-model="newNameRow"
                                :rules="[rules.notEmpty, rules.rowNameDoesntExist]"
                                label="Description de la nouvelle ligne"
                                density="compact"
                            >
                            </v-text-field-filled>
                            <v-checkbox
                                v-model="newDisplaySignRow"
                                label="Inverser le signe"
                                :false-value="-1"
                                :true-value="1"
                                class="ma-0"
                                hint="Si coché, les charges seront de signe positif (et les produits de signe négatif)"
                                persistent-hint
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" class="title pl-3 pt-2"> Conditions </v-col>
                        <v-col cols="12" class="pl-3 pt-2">
                            <v-row
                                no-gutters
                                v-for="(cont, index) of newRulesRow"
                                :key="index + '_' + refreshKey"
                                class="d-flex justify-center"
                            >
                                <v-col cols="1" class="d-flex align-center justify-center">
                                    {{ index !== 0 ? "ET" : "SI" }}
                                </v-col>
                                <v-col cols="2" class="pb-1">
                                    <v-select-filled
                                        v-model="cont.operator"
                                        :items="operators"
                                        :rules="[rules.notEmpty]"
                                        density="compact"
                                    >
                                    </v-select-filled>
                                </v-col>
                                <v-col
                                    cols="5"
                                    class="pb-1 pl-2"
                                    v-if="cont.operator === 'equalTo'"
                                >
                                    <v-autocomplete-filled
                                        v-model="cont.numbers"
                                        :items="scopedAccountableAccounts"
                                        :item-title="(item) => displayVChip(item.name || item)"
                                        :item-value="(item) => item.name"
                                        :rules="[rules.notEmptyAutocomplete]"
                                        label="l'un de ces comptes comptables"
                                        chips
                                        multiple
                                        closable-chips
                                    />
                                </v-col>
                                <v-col
                                    cols="5"
                                    class="d-flex align-center justify-center pl-2"
                                    v-else-if="cont.operator === 'startsWith'"
                                >
                                    <v-combobox-filled
                                        v-model="cont.numbers"
                                        label="un de ces comptes racines"
                                        :item-title="(item) => displayVChip(item)"
                                        multiple
                                        chips
                                        closable-chips
                                        item-disabled
                                        density="compact"
                                        :disabled="!cont.operator"
                                        :rules="[rules.notEmptyAutocomplete, rules.onlyNumbers]"
                                        append-inner-icon="$fa-ban"
                                        @click:appendInner="displayNotStartsWith(cont)"
                                    />
                                    <!-- v-if="cont.displayNotStartsWith" -->
                                    <v-combobox-filled
                                        v-model="cont.notStartsWith"
                                        label="Et ne démarre pas par"
                                        multiple
                                        chips
                                        closable-chips
                                        density="compact"
                                        :items="scopedAccountableAccounts"
                                        :item-value="(item) => item.name"
                                        :item-title="(item) => displayVChip(item.name || item)"
                                        :return-object="false"
                                        :rules="[rules.onlyNumbers]"
                                        v-show="
                                            (cont.notStartsWith && cont.notStartsWith.length) ||
                                            cont.displayNotStartsWith
                                        "
                                    />
                                </v-col>
                                <v-col
                                    cols="3"
                                    class="pb-1"
                                    v-if="
                                        cont.operator === 'startsWith' ||
                                        cont.operator === 'equalTo'
                                    "
                                >
                                    <v-select-filled
                                        v-model="cont.debitOrCredit"
                                        :items="operatorsDebitOrCredit"
                                        class="ml-2"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col cols="8" v-else />
                                <v-col col="1" class="d-flex align-top justify-center">
                                    <v-btn-trash
                                        v-if="newRulesRow.length > 1"
                                        size="x-small"
                                        @click="removeCondition(index)"
                                    />
                                    <v-btn-add-icon
                                        v-if="index + 1 === newRulesRow.length"
                                        size="x-small"
                                        @click="addCondition()"
                                    >
                                    </v-btn-add-icon>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-form>
                <!-- <ComputedIndicatorCreator  V_CI
                    :actions="CI_creatorActions"
                ></ComputedIndicatorCreator> -->
            </div>

            <template v-slot:actions>
                <v-btn-primary
                    :disabled="!isValid"
                    rounded
                    block
                    @click="edit ? validateModificatedRow() : validateNewRow()"
                    size="x-large"
                    >{{ edit ? "Modifier" : "Ajouter" }}</v-btn-primary
                >
            </template>
        </oss-dialog>

        <oss-dialog v-model="dialogChooseSig" title="Ajouter un solde intermédiaire" width="70vw">
            <!-- <ComputedIndicatorSelector  // V_CI
                :companyId="accountingCompanyId"
            ></ComputedIndicatorSelector> -->
            <v-row no-gutters class="pb-2">
                <v-col>
                    <v-text-field-filled
                        v-model="searchBar"
                        label="Rechercher"
                        single-line
                        density="compact"
                        clearable
                        append-inner-icon="$search"
                        @click:clear="search = ''"
                    />
                </v-col>
            </v-row>

            <v-list>
                <template v-for="(item, index) in listIntermediateBalances" :key="item.index">
                    <v-list-item
                        :class="
                            !$vuetify.display.mobile
                                ? 'mb-2 oss-list-item'
                                : 'mb-2 px-2 oss-list-item'
                        "
                        :ripple="true"
                        @click="addIntermediaireBalance(item)"
                    >
                        <template v-slot:append>
                            <v-btn-next />
                        </template>
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item>
                </template>
            </v-list>
        </oss-dialog>

        <oss-dialog
            v-model="dialogAddTotal"
            :title="edit ? 'Modifier ce total' : 'Ajouter une ligne total'"
        >
            <div style="width: 80vw">
                <v-form v-model="isValid2">
                    <v-row no-gutters>
                        <v-col cols="12" class="title px-3 pt-2"> Nom de la ligne totale </v-col>
                        <v-col cols="11" class="d-flex justify-center align-top mx-2">
                            <v-text-field-filled
                                v-model="newNameRow"
                                :rules="[rules.notEmpty, rules.rowNameDoesntExist]"
                                label="Description de la nouvelle ligne"
                                outlined
                                single-line
                                hide-details
                                density="compact"
                            />
                            <v-checkbox
                                v-model="newDisplaySignRow"
                                label="Inverser le signe"
                                :false-value="-1"
                                :true-value="1"
                                class="ma-0 pb-2"
                                hint="Si coché, les charges seront de signe positif (et les produits de signe négatif)"
                                persistent-hint
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="11" class="d-flex justify-center mx-2">
                            <v-select-filled
                                v-model="typeOfTotal"
                                :items="itemsTypeOfTotal"
                                class="mr-2"
                                :style="itemsTypeOfTotalStyle"
                                density="compact"
                                @update:model-value="reinitialiseListTotaux()"
                            />
                            <v-autocomplete-filled
                                v-model="listTotauxToAdd"
                                :items="itemsToAdd()"
                                item-value="key"
                                :rules="[rules.notEmptyAutocomplete]"
                                label="choisissez les totaux qui s'ajouteront"
                                chips
                                multiple
                                closable-chips
                                density="compact"
                                v-if="typeOfTotal !== 'justPreviousRows'"
                            />
                        </v-col>
                    </v-row>
                </v-form>
            </div>

            <template v-slot:actions>
                <v-btn-primary
                    :disabled="!isValid2"
                    rounded
                    block
                    @click="edit ? validateModificatedTotal() : validateNewTotal()"
                    size="x-large"
                    >{{ edit ? "Modifier" : "Ajouter" }}</v-btn-primary
                >
            </template>
        </oss-dialog>

        <oss-dialog
            v-model="dialogAddRatio"
            :title="edit ? 'Modifier ce taux' : 'Ajouter un taux'"
            width="70vw"
        >
            <v-form v-model="isValid3">
                <v-row no-gutters>
                    <v-col cols="12" class="title px-3 pt-2">
                        Nom de la ligne (taux)
                        <span class="subtitle-2">x/y (en %)</span>
                        <!-- <span class="subtitle-2">(x + y)/y</span> -->
                    </v-col>
                    <v-col cols="11" class="d-flex mx-2">
                        <v-text-field-filled
                            v-model="newNameRow"
                            :rules="[rules.notEmpty, rules.rowNameDoesntExist]"
                            label="Description de la nouvelle ligne"
                            outlined
                            single-line
                            hide-details
                            density="compact"
                        />
                        <v-checkbox
                            v-model="newDisplaySignRow"
                            class="d-flex align-center"
                            label="Inverser le signe (charges/produits de signe positif)"
                            :false-value="-1"
                            :true-value="1"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="11" class="d-flex justify-center mx-2">
                        <v-select-filled
                            v-model="newKey1"
                            :items="rowsWithoutRatios"
                            :item-title="(x) => x.name || x.title"
                            :item-value="(x) => x.key || x.name || x.title"
                            :rules="[rules.notEmpty]"
                            label="x"
                            outlined
                            density="compact"
                        />
                        <v-select-filled
                            v-model="newKey2"
                            :items="rowsWithoutRatios"
                            :item-title="(x) => x.name || x.title"
                            :item-value="(x) => x.key || x.name || x.title"
                            :rules="[rules.notEmpty]"
                            label="y"
                            outlined
                            class="ml-2"
                            density="compact"
                        />
                        <v-select-filled
                            v-model="newKeyToModify"
                            :items="toModifyKeys"
                            label="Valeur à modifier"
                            outlined
                            class="ml-2"
                            density="compact"
                        />
                    </v-col>
                </v-row>
            </v-form>

            <template v-slot:actions>
                <v-btn-primary
                    :disabled="!isValid3"
                    rounded
                    block
                    @click="edit ? validateModificatedRatio() : validateNewRatio()"
                    size="x-large"
                    >{{ edit ? "Modifier" : "Ajouter" }}</v-btn-primary
                >
            </template>
        </oss-dialog>

        <oss-dialog v-model="dialogTab" title="Les comptes non attribués" width="70vw">
            <v-data-table
                :headers="headers2"
                :items="AArestants"
                :items-per-page="-1"
                hide-default-footer
                no-data-text="Tous les comptes (tels que définis dans la portée) sont utilisés"
                density="compact"
                class="table"
            >
                <template v-slot:item="props">
                    <tr :key="props.item.index">
                        <td width="60%">
                            {{ props.item.displayName || props.item.name }} -
                            {{ props.item.description }}
                        </td>

                        <td width="30%" style="font-size: smaller; font-style: italic">
                            {{ displayDebitCreditOnlyForTab(props.item.name) }}
                        </td>

                        <td width="10%">
                            <v-checkbox
                                v-model="selectionTab"
                                v-if="!readOnly"
                                :value="props.item.name"
                            />
                        </td>
                    </tr>
                </template>
            </v-data-table>

            <template v-slot:actions>
                <v-btn-primary
                    :disabled="selectionTab.length === 0 || readOnly"
                    rounded
                    block
                    @click="
                        dialogFromTab = true;
                        dialogTab = false;
                    "
                    size="x-large"
                    >Ajouter à une ligne</v-btn-primary
                >
            </template>
        </oss-dialog>

        <oss-dialog
            v-model="dialogFromTab"
            title="Sélectionnez la ligne où ajouter les comptes"
            width="70vw"
        >
            <v-data-table :items="rulesRows" :items-per-page="-1" hide-default-footer class="table">
                <template v-slot:item="props">
                    <tr :key="props.item.index" v-if="props.item.name && !props.item.marginRatio">
                        <td>
                            {{ props.item.name }}
                        </td>
                        <td>
                            <span
                                v-for="(condition, i) in props.item.netAmounts"
                                :key="i + '_Condition'"
                            >
                                <span
                                    v-for="(accountableAccount, i) in condition.numbers"
                                    :key="i + '_Numbers'"
                                >
                                    <v-tooltip location="bottom">
                                        <template v-slot:activator="{ props }">
                                            <v-chip
                                                color="error"
                                                class="mx-1"
                                                v-if="
                                                    checkNumberAAconcerned(accountableAccount) === 0
                                                "
                                                v-bind="props"
                                                size="small"
                                            >
                                                {{ accountableAccount }}
                                            </v-chip>
                                            <v-chip
                                                class="mx-1"
                                                v-else-if="isOverflowRange(accountableAccount)"
                                                v-bind="props"
                                                size="small"
                                            >
                                                {{ accountableAccount }}
                                            </v-chip>
                                            <v-chip
                                                color="secondary"
                                                class="mx-1"
                                                v-else
                                                v-bind="props"
                                                size="small"
                                            >
                                                {{ accountableAccount }}
                                            </v-chip>
                                        </template>
                                        <span
                                            v-if="
                                                isOverflowRange(accountableAccount) &&
                                                checkNumberAAconcerned(accountableAccount) !== 0
                                            "
                                            >Ce compte déborde de la portée.
                                        </span>
                                        <span
                                            >Nombre de comptes concernés :
                                            {{ checkNumberAAconcerned(accountableAccount) }}</span
                                        >
                                    </v-tooltip>
                                </span>
                            </span>
                        </td>
                        <td colspan="2">
                            <v-btn
                                rounded
                                elevation="0"
                                class="ml-4"
                                @click="integrationAACheckedIntoRulesRows(props.item.name)"
                                size="small"
                            >
                                Ajouter
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

// import GENERAL_ACCOUNTABLE_ACCOUNTS from "../../graphql/accountableAccount/GeneralAccountableAccounts.gql";
import ACCOUNTABLE_ACCOUNTS_STARTS_WITH from "../../graphql/accountableAccount/AccountableAccountsStartsWith.gql";
import ACCOUNTABLE_ACCOUNTS_USED from "../../graphql/accountableAccount/AccountableAccountsUsed.gql";
import GENERAL_INTERMEDIATE_BALANCES from "../../graphql/RangedIntermediateBalances.gql";
import OPERATING_ACCOUNT from "../../graphql/OperatingAccount.gql";
import UPSERT_OPERATING_ACCOUNT from "../../graphql/UpsertOperatingAccount.gql";

import ossAccountableAccountSelector from "../ossComponents/ossAccountableAccountSelector.vue";
import ScopeManager from "../companyScope/ScopeManager.vue";
import ComputedIndicatorCreator from "../computedIndicator/ComputedIndicatorCreator.vue";
import ComputedIndicatorSelector from "../computedIndicator/ComputedIndicatorSelector.vue";
import { User } from "../../store/store";
import { filterAccountableAccounts } from "../../../../backend/src/common/accountableAccount/accountableAccountServices";

import { v4 as uuid } from "uuid";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { Ref } from "vue-facing-decorator";

type typeOfTotal = "justPreviousRows" | "previousRowsAndTotals" | "chooseLines";

@Component({
    components: {
        ossAccountableAccountSelector,
        ScopeManager,
        ComputedIndicatorCreator,
        ComputedIndicatorSelector,
    },
})
export class OperatingAccountSheet extends Vue {
    @Prop({ default: null }) idSheet: String;

    @Model({ type: String, name: "companyScope" }) scopeSync!: any;
    @Ref() readonly scopeManager!: any;

    title = "";
    rulesRows = [];
    range = [];
    type = "MISCELLANEOUS";

    OA_Tables = [
        {
            columns: [
                {
                    name: "",
                    key: "netAmounts",
                },
            ],
            comparison: {
                index: 0,
                difference: true,
                percentage: true,
            },
            relativePercentage: 0,
            rows: [],
        },
    ];

    readOnly = false;

    outOfPCF = {};
    outOfRangeDico = {};
    inRange: any = {};
    dicoDebitCredit: any = {};

    subAccountableAccounts: any = {};

    dialogAddOrEditRow = false;
    edit = false;
    newNameRow = "";
    newDisplaySignRow = -1;
    newRulesRow = [
        { operator: "startsWith", numbers: [], debitOrCredit: "both", notStartsWith: [] },
    ];
    newKey1 = "";
    newKey2 = "";
    newKeyToModify = "";
    toModifyKeys = [
        { title: "x", value: "key1" },
        { title: "y", value: "key2" },
    ];
    index = 0;
    tableIndex = 0;
    isValid = false;
    isValid2 = false;
    isValid3 = false;
    typeOfTotal: typeOfTotal = "justPreviousRows";
    listTotauxToAdd = [];

    allAccountingCompany = false;
    scopeSharingStatus = "";

    dialogTab = false;
    dialogFromTab = false;
    selectionTab = [];
    isFinished = false;
    doublons = [];

    errorRatioKey = false;

    dialogChooseSig = false;
    searchBar = "";

    dialogAddTotal = false;

    dialogAddRatio = false;

    refreshKey = 0;

    // headers(table) {
    //     const emptyHeader = [{ text: ' ', sortable: false }]
    //     const colomnsHeaders = []
    //     for(const col of table.columns) {
    //         if(col === table.columns[table.columns - 1] && table.columns > 1) { // dans le cas du bilan on enleve la colonne du net
    //             continue
    //         } else {
    //             colomnsHeaders.push(table.columns)
    //         }
    //         colomnsHeaders[colomnsHeaders.length - 1].sortable = false;
    //         colomnsHeaders[colomnsHeaders.length - 1].class = Array;
    //     }
    //     const result = [
    //         ...emptyHeader, { text: 'description', value: 'name' }, ...colomnsHeaders, ...emptyHeader, ...emptyHeader
    //     ]
    //     debugger
    //     return result
    // }

    headers(table) {
        const beginningHeader = [
            { title: " ", sortable: false },
            { title: "Description", value: "name" },
        ];
        const midHeader = this.tableColumns(table);
        const endHeader = [
            { title: " ", sortable: false },
            { title: " ", sortable: false },
        ];
        return beginningHeader.concat(midHeader.concat(endHeader));
    }

    tableColumns(table) {
        const result = [];
        if (!table) {
            return result;
        }
        if (table.columns?.length > 1) {
            for (const c of table.columns) {
                if (c.key !== "netAmounts") {
                    result.push({ title: c.name, value: c.key, class: Array, sortable: false });
                }
            }
        } else {
            result.push({
                title: "comptes comptables",
                value: "netAmounts",
                class: Array,
                sortable: false,
            });
        }
        if (!result || result.length === 0) {
            debugger;
        }
        return result;
    }

    headers2 = [
        {
            title: "comptes comptables non utilisés",
            value: "",
            width: "60%",
        },
        {
            title: "",
            width: "30%",
        },
        {
            title: "",
            sortable: false,
        },
    ];

    operators = [
        { title: "Egal à", value: "equalTo" },
        { title: "Démarre par", value: "startsWith" },
        // { title: "Fini par", value: "endsWith" },
    ];

    operatorsDebitOrCredit = [
        { title: "Débit et crédit", value: "both" },
        { title: "Debit uniquement", value: "debitOnly" },
        { title: "Credit uniquement", value: "creditOnly" },
    ];

    itemsTypeOfTotal: Array<{ title: String; value: typeOfTotal }> = [
        {
            title: "Total des lignes précédentes (entre ce total et le précédent)",
            value: "justPreviousRows",
        },
        {
            title: "Ajouter certains totaux précédents ('Total des lignes précédentes' + les totaux que vous voulez)",
            value: "previousRowsAndTotals",
        },
        { title: "Additionner les lignes que vous voulez", value: "chooseLines" },
    ];

    uses = [
        {
            value: "OPERATING_ACCOUNT",
            title: "Compte d'exploitation",
        },
        {
            value: "CASH_FLOW_PLAN",
            title: "Plan de trésorerie",
        },
    ];

    use = "OPERATING_ACCOUNT";

    types = [
        { value: "SIG", title: "SIG" },
        { value: "FLASH_SITUATION", title: "Flash" },
        { value: "INCOME_STATEMENT", title: "Compte de résultats" },
        { value: "MISCELLANEOUS", title: "Personnalisé" },
    ];

    scopeName: string = "";
    scopeId_: string = "";

    get scopeId() {
        if (this.scopeSync?.id) {
            this.scopeId_ = this.scopeSync?.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    @Watch("dialogAddOrEditRow") // to delete
    closeDialog1() {
        if (this.dialogAddOrEditRow === false) {
            this.index = 0;
            this.tableIndex = 0;
            this.newNameRow = "";
            this.newDisplaySignRow = -1;
            this.newRulesRow = [
                { operator: "startsWith", numbers: [], debitOrCredit: "both", notStartsWith: [] },
            ];
            this.isValid = false;
        }
    }

    @Watch("dialogTab")
    closeDialog2() {
        if (this.dialogFromTab === false) {
            this.selectionTab = [];
        }
    }

    @Watch("dialogFromTab")
    closeDialog3() {
        if (this.dialogFromTab === false) {
            this.selectionTab = [];
        }
    }

    @Watch("dialogAddTotal")
    closeDialog4() {
        if (this.dialogAddTotal === false) {
            this.isValid2 = false;
            this.newNameRow = "";
            this.newDisplaySignRow = -1;
            this.typeOfTotal = "justPreviousRows";
            this.listTotauxToAdd = [];
        }
    }

    @Watch("dialogAddRatio")
    closeDialogRatio() {
        if (this.dialogAddRatio === false) {
            this.newNameRow = "";
            this.newDisplaySignRow = -1;
            this.newKey1 = "";
            this.newKey2 = "";
            this.newKeyToModify = "key1";
            this.isValid3 = false;
        }
    }

    get rules() {
        return {
            notEmpty: (value) => {
                return !!value || "A remplir";
            },
            notEmptyAutocomplete: (value) => {
                if (value instanceof Array && value.length == 0) {
                    return "Il faut remplir une de ces conditions";
                }
                return !!value || "Il faut remplir une de ces conditions";
            },
            onlyNumbers: (value) => {
                for (const v of value) {
                    if (/^[0-9]{6}_.+/.test(v)) {
                        return true;
                    } // for subAccountableAccountOf
                    if (v.startsWith("0") || !/^[0-9]+$/.test(v)) {
                        return "Seuls des comptes racines sont acceptés";
                    }
                }
                return true;
            },
            rowNameDoesntExist: (value) => {
                const index = this.OA_Tables[0].rows.findIndex(
                    (e) => e.name === value || e.title === value,
                );
                if (index !== -1 && index !== this.index) {
                    return "Ce nom de ligne existe déjà";
                }
                return true;
            },
        };
    }

    get accountingCompanyId() {
        return this.$store.state.user.company.id;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isRootProfile() {
        return this.currentUser.isRoot;
    }

    get userId() {
        return this.$store.state.user.id;
    }

    get isDisabled() {
        if (!this.title || !this.accountableAccountsUsed.length) {
            return true;
        }
        if (!this.scopeId) {
            return true;
        }
        return false;
    }

    checkIsEmpty(dico) {
        for (const i in dico) {
            return false;
        }
        return true;
    }

    get rangeForGQL() {
        const result = [];
        for (const r of this.range) {
            result.push({ name_starts_with: r });
        }
        if (!result.length) {
            result.push({ name_starts_with: "" });
        }
        return result;
    }

    get AArestants() {
        const result = [];
        for (const aa of this.scopedAccountableAccounts) {
            if (this.inRange[aa.name] === 0) {
                if (/^[0-9]{2}0{4}/.test(aa.name)) {
                    // cette ligne permet d'écarter les comptes comptables uniques à bobbee, il faut supprimer cette ligne si on veut les afficher
                } else {
                    result.push(aa);
                    continue;
                }
            } else if (this.inRange[aa.name] > 0 && this.inRange[aa.name] % 1) {
                if (this.dicoDebitCredit && Object.keys(this.dicoDebitCredit).length) {
                    const d = this.dicoDebitCredit[aa.name];
                    if ((d.credit && !d.debit) || (d.debit && !d.credit)) {
                        result.push(aa);
                    } else {
                        debugger; /* git-ignore   should never happen */
                    }
                } else {
                    debugger; /* git-ignore   should never happen */
                }
            }
        }
        return result;
    }

    get rowsWithoutRatios() {
        const result = [];
        for (const table of this.OA_Tables) {
            for (const row of table.rows) {
                if (!row.marginRatio) {
                    result.push(row);
                }
            }
        }
        return result;
    }

    itemsToAdd(tableIndex = 0): Array<{ title: string; key: string }> {
        const result = [];
        const rows = this.OA_Tables[tableIndex].rows;
        for (const row of rows) {
            if (this.typeOfTotal === "previousRowsAndTotals") {
                if (row.title) {
                    result.push({ title: row.title, key: row.key });
                }
            } else if (this.typeOfTotal === "chooseLines") {
                if (!row.marginRatio) {
                    result.push({ title: row.title || row.name, key: row.key });
                }
            }
        }
        return result;
    }

    get itemsTypeOfTotalStyle() {
        return this.typeOfTotal === "justPreviousRows" ? "max-width: 100%;" : "max-width: 60%;";
    }

    @Watch("newRulesRow", { deep: true })
    adaptOperator() {
        //gère le cas où l'utilisateur rentre le nombre de son choix en mode 'démarre par' et switch sur un 'égal à'
        for (const rule of this.newRulesRow) {
            if (rule.operator === "equalTo") {
                for (const numberIndex in rule.numbers) {
                    if (
                        this.scopedAccountableAccounts.findIndex(
                            (e) => e.name === rule.numbers[parseInt(numberIndex)],
                        ) === -1
                    ) {
                        rule.numbers.splice(parseInt(numberIndex), 1);
                    }
                }
            }
        }
    }

    accountableAccountsUsed = [];

    @Watch("OA_Tables", { deep: true })
    convergeTables() {
        const allAccountableAccounts = [];
        for (const table of this.OA_Tables) {
            for (const row of table.rows) {
                if (row.name && !row.marginRatio) {
                    const formatedRule: any = { name: row.name };
                    for (const col of table.columns) {
                        if (row.columns?.[col.key]) {
                            if (!formatedRule.netAmounts) {
                                formatedRule.netAmounts = [];
                            }
                            for (const c of row.columns[col.key]) {
                                const condition: any = {};
                                if (c.startsWith) {
                                    condition.numbers = c.startsWith;
                                }
                                if (c.notStartsWith) {
                                    condition.notStartsWith = c.notStartsWith;
                                }
                                if (c.debitOnly) {
                                    condition.debitOnly = true;
                                }
                                if (c.creditOnly) {
                                    condition.creditOnly = true;
                                }
                                formatedRule.netAmounts.push(condition);
                            }
                        }
                    }
                    if (row.key) {
                        formatedRule.key = row.key;
                    }
                    allAccountableAccounts.push(formatedRule);
                }
            }
        }
        this.accountableAccountsUsed = allAccountableAccounts;
    }

    @Watch("scopedAccountableAccounts")
    @Watch("accountableAccountsUsed", { deep: true })
    compute() {
        const tempoOutOfPCF = {};
        const tempoOutOfRangeDico = {};
        const tempoInRange = {};
        const tempoDicoDebitCredit = {};
        if (this.globalAccountablAccounts.length && this.scopedAccountableAccounts.length) {
            for (const aa of this.scopedAccountableAccounts) {
                tempoInRange[aa.name] = 0;
                // if(this.scopedAccountableAccounts.find(aa)) {
                //     this.inRange[aa.name] = 0
                // }
            }
            for (const row of this.accountableAccountsUsed) {
                if (row.name && !row.marginRatio) {
                    for (const condition of row.netAmounts) {
                        for (const number of condition.numbers) {
                            let isInPCF = false;
                            for (const aa of this.globalAccountablAccounts) {
                                if (aa.name.startsWith(number)) {
                                    isInPCF = true;
                                    if (tempoInRange[aa.name] !== undefined) {
                                        if (condition.debitOnly) {
                                            this.addElementDicoDebitCredit(
                                                aa.name,
                                                tempoDicoDebitCredit,
                                                "debit",
                                            );
                                        } else if (condition.creditOnly) {
                                            this.addElementDicoDebitCredit(
                                                aa.name,
                                                tempoDicoDebitCredit,
                                                "credit",
                                            );
                                        } else {
                                            tempoInRange[aa.name] += 1;
                                        }
                                    } else {
                                        tempoOutOfRangeDico[aa.name] = true;
                                    }
                                }
                            }
                            if (!isInPCF) {
                                tempoOutOfPCF[number] = true;
                            }
                        }
                        if (condition.notStartsWith) {
                            for (const notStartsWith of condition.notStartsWith) {
                                for (const aa of this.globalAccountablAccounts) {
                                    if (aa.name.startsWith(notStartsWith)) {
                                        if (tempoInRange[aa.name] !== undefined) {
                                            if (condition.debitOnly) {
                                                this.addElementDicoDebitCredit(
                                                    aa.name,
                                                    tempoDicoDebitCredit,
                                                    "notDebit",
                                                );
                                            } else if (condition.creditOnly) {
                                                this.addElementDicoDebitCredit(
                                                    aa.name,
                                                    tempoDicoDebitCredit,
                                                    "notCredit",
                                                );
                                            } else {
                                                tempoInRange[aa.name]--;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        this.manageDicoDebitCredit(tempoDicoDebitCredit, tempoInRange);
        this.dicoDebitCredit = tempoDicoDebitCredit;
        this.outOfPCF = tempoOutOfPCF;
        this.outOfRangeDico = tempoOutOfRangeDico;
        this.inRange = tempoInRange;
        const tempoDoublons = [];
        for (const index in this.inRange) {
            if (tempoInRange[index] > 1) {
                tempoDoublons.push(index);
            }
        }
        this.errorRatioKey = false;
        this.doublons = tempoDoublons;

        if (
            !this.OutOfPCF &&
            this.doublons.length === 0 &&
            !this.isDisabled &&
            this.flagCondition()
        ) {
            this.isFinished = true;
        } else {
            this.isFinished = false;
        }
        this.isFinished = true;
    }

    get OutOfPCF() {
        return !this.checkIsEmpty(this.outOfPCF);
    }

    flagCondition() {
        // flag
        if (this.isRootProfile) {
            return true;
        } else {
            return (
                (this.checkIsEmpty(this.outOfRangeDico) && this.AArestants.length === 0) ||
                this.range.length === 0
            );
        }
    }

    // @Apollo({
    //     query: ACCOUNTABLE_ACCOUNTS_STARTS_WITH,
    //     variables(){
    //         return {
    //             range: this.rangeForGQL,
    //             companyId: this.assignedCompaniesForGql?.length === 1 ? this.assignedCompaniesForGql[0].id : undefined
    //         }
    //     },
    //     skip() {
    //         return this.onlyUsedAccountableAccounts
    //     },
    //     result({data, loading}: any) {
    //         if(data && data.accountableAccounts){
    //             const temporaireListAARanged = []
    //             for( const i of data.accountableAccounts ) {
    //                 if (i.name.length === 6 || ( i.name.length > 6 && new RegExp(/^[0-9]{6}_[a-zA-Z0-9]{32}/g).test(i.name) ) ){
    //                     temporaireListAARanged.push(i)
    //                     // if(i.length > 6) {debugger}
    //                     if(i.subAccountableAccountOfId && this.assignedCompaniesForGql?.length === 1) {
    //                         this.subAccountableAccounts[i.name] = { ...i } // demander Romain si copie ?
    //                     }
    //                 }
    //             }
    //             this.rangedAccountableAccounts = temporaireListAARanged
    //         } else {
    //             this.rangedAccountableAccounts = []
    //         }
    //     }
    // })

    get rangedAccountableAccounts() {
        const accountableAccounts = filterAccountableAccounts(
            this.$store.state.accountableAccountTable,
            this.range,
            [],
        );
        const temporaireListAARanged = [];
        for (const i of accountableAccounts) {
            if (
                i.name.length === 6 ||
                (i.name.length > 6 && new RegExp(/^[0-9]{6}_[a-zA-Z0-9]{32}/g).test(i.name))
            ) {
                temporaireListAARanged.push(i);
                // if(i.length > 6) {debugger}
                if (
                    i.subAccountableAccountOfId &&
                    this.scopeManager?.companyScopeArrays?.clients?.length === 1
                ) {
                    this.subAccountableAccounts[i.name] = { ...i }; // demander Romain si copie ?
                }
            }
        }
        return temporaireListAARanged;
    }

    // get rangedAccountableAccounts() {
    //     debugger
    //     const withSubAccount = this.assignedCompaniesForGql?.length === 1
    //     const accountableAccounts = filterAccountableAccounts(this.$store.state.accountableAccountTable,this.range, [], withSubAccount)
    //     const temporaireListAARanged = []
    //     for( const i of accountableAccounts ) {
    //         if (i.name.length === 6 || ( i.name.length > 6 && new RegExp(/^[0-9]{6}_[a-zA-Z0-9]{32}/g).test(i.name) ) ) {
    //             temporaireListAARanged.push(i)
    //             // if(i.length > 6) {debugger}
    //             if(i.subAccountableAccountOfId && this.assignedCompaniesForGql?.length === 1) {
    //                 this.subAccountableAccounts[i.name] = { ...i } // demander Romain si copie ?
    //             }
    //         }
    //     }
    //     return temporaireListAARanged
    // }

    @Apollo({
        query: ACCOUNTABLE_ACCOUNTS_USED,
        variables() {
            return {
                companyId: this.scopeManager.companyScopeArrays.clients[0].id,
                mode: "bankTransaction",
            };
        },
        skip() {
            return !this.onlyUsedAccountableAccounts || !this.scopeId;
        },
        result({ data, loading }: any) {
            if (data && data.usedAccountableAccounts) {
                this.usedAccountableAccounts = data.usedAccountableAccounts;
            } else {
                this.usedAccountableAccounts = [];
            }
        },
    })
    usedAccountableAccounts: any = [];

    get scopedAccountableAccounts() {
        if (this.onlyUsedAccountableAccounts) {
            return this.usedAccountableAccounts;
        }
        return this.rangedAccountableAccounts;
    }

    addElementDicoDebitCredit(aaName, tempoDicoDebitCredit, key) {
        if (!tempoDicoDebitCredit[aaName]) {
            tempoDicoDebitCredit[aaName] = {};
        }
        if (!tempoDicoDebitCredit[aaName][key]) {
            tempoDicoDebitCredit[aaName][key] = 0;
        }
        tempoDicoDebitCredit[aaName][key]++;
    }

    manageDicoDebitCredit(tempoDicoDebitCredit, tempoInRange) {
        if (Object.keys(tempoDicoDebitCredit).length) {
            for (const [index, d] of Object.entries(tempoDicoDebitCredit) as any[]) {
                if (d.credit && d.notCredit) {
                    const memoir = d.credit;
                    d.credit -= d.notCredit;
                    d.notCredit -= memoir;
                }
                if (d.debit && d.notDebit) {
                    const memoir = d.debit;
                    d.debit -= d.notDebit;
                    d.notDebit -= memoir;
                }
                while (d.credit >= 1 && d.debit >= 1) {
                    tempoInRange[index]++;
                    d.credit--;
                    d.debit--;
                }
                if (d.credit > 1) {
                    tempoInRange[index] += 1.01;
                }
                if (d.credit === 1) {
                    tempoInRange[index] += 0.01;
                }
                if (d.debit > 1) {
                    tempoInRange[index] += 1.0001;
                }
                if (d.debit === 1) {
                    tempoInRange[index] += 0.0001;
                }
            }
        }
    }

    // @Apollo({
    //     query: GENERAL_ACCOUNTABLE_ACCOUNTS,
    //     variables(){
    //         return {
    //             companyId: this.assignedCompaniesForGql?.length === 1 ? this.assignedCompaniesForGql[0].id : undefined,
    //         }
    //     },
    //     result({data, loading}: any) {
    //         if(data && data.accountableAccounts){
    //             const temporaireListAA = []
    //             for( const i of data.accountableAccounts ) {
    //                 if (i.name.length === 6 || ( i.name.length > 6 && new RegExp(/^[0-9]{6}_[a-zA-Z0-9]{32}/g).test(i.name) ) ){
    //                     temporaireListAA.push(i)
    //                 }
    //             }
    //             this.dbAccountableAccounts = temporaireListAA
    //             this.compute()
    //         }
    //     }
    // })
    get dbAccountableAccounts() {
        return this.$store.state.accountableAccountTable?.accountableAccounts || [];
    }

    get globalAccountablAccounts() {
        if (this.onlyUsedAccountableAccounts) {
            return this.usedAccountableAccounts;
        }
        return this.dbAccountableAccounts;
    }

    @Apollo({
        // to move into indicator component
        query: GENERAL_INTERMEDIATE_BALANCES,
        variables() {
            return { search: this.searchBar, range: this.rangeForGQL };
        },
        skip() {
            return !this.dialogChooseSig;
        },
        result({ data, loading }: any) {
            if (data && data.rangedIntermediateBalances) {
                const result = JSON.parse(JSON.stringify(data.rangedIntermediateBalances.data));
                this.listIntermediateBalances = result;
            }
        },
    })
    listIntermediateBalances: any = [];
    // result({data, loading}: any) {  V_CI
    //         if(data && data.rangedComputedIndicators){
    //             const result = JSON.parse(JSON.stringify(data.rangedComputedIndicators.data))
    //             this.listComputedIndicators = result

    @Apollo({
        query() {
            return OPERATING_ACCOUNT;
        },
        variables() {
            return { id: this.idSheet };
        },
        skip() {
            return this.idSheet === null;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.operatingAccount) {
                    // const dataCopy = JSON.parse(JSON.stringify(data))
                    this.title = data.operatingAccount.name;
                    this.scopeId = data.operatingAccount.companyScope.id;
                    this.scopeName = data.operatingAccount.companyScope.name || "";
                    this.range = data.operatingAccount.data[0].range
                        ? data.operatingAccount.data[0].range
                        : [];
                    this.allAccountingCompany = data.operatingAccount.companyScope.accountingCompany
                        ? false
                        : true;
                    this.scopeSharingStatus = data.operatingAccount.companyScope.scopeSharingStatus;
                    this.OA_Tables = data.operatingAccount.data;
                    this.importSuccess = true;
                    this.use = data.operatingAccount.use;
                    this.type = data.operatingAccount.type;
                    this.computeReadOnly(
                        data.operatingAccount.companyScope.accountingCompany,
                        data.operatingAccount.companyScope.accountingCompanyOwner,
                    );
                } else {
                    this.importSuccess = false;
                }
            }
        },
    })
    importSuccess: Boolean = false;

    computeReadOnly(accountingCompany, accountingCompanyOwner) {
        if (
            (accountingCompany == null || accountingCompanyOwner === null) &&
            accountingCompanyOwner?.id !== this.accountingCompanyId
        ) {
            this.readOnly = true;
        } else if (this.type === "BALANCE_SHEET") {
            this.readOnly = true;
        } else {
            this.readOnly = false;
        }
    }

    convertDataRowsIntoRulesRows(data) {
        this.OA_Tables = data.operatingAccount.data;
    }

    findTitle(key) {
        for (const row of this.rowsWithoutRatios) {
            if (row.key === key) {
                return row.name || row.title;
            }
        }
        this.errorRatioKey = true;
        return "la ligne n'existe plus";
    }

    removeCondition(index) {
        // to delete V_CI
        this.newRulesRow.splice(index, 1);
    }

    addCondition() {
        // to delete V_CI
        this.newRulesRow.push({
            operator: "",
            numbers: [],
            debitOrCredit: "both",
            notStartsWith: [],
        });
    }

    editRow2(index, tableIndex = 0) {
        const rowToEdit = this.OA_Tables[tableIndex].rows[index];
        this.edit = true;
        this.newNameRow = rowToEdit.name;
        this.newDisplaySignRow = rowToEdit.displaySign;
        this.newRulesRow = [];
        if (rowToEdit.marginRatio) {
            this.newKey1 = rowToEdit.input.key1;
            this.newKey2 = rowToEdit.input.key2;
            this.newKeyToModify = rowToEdit.input.modify;
            this.dialogAddRatio = true;
        } else {
            this.newRulesRow = this.convertNetAmountsIntoNewRulesRow(rowToEdit.columns.netAmounts);
            // for(const netAmou of rowToEdit.columns.netAmounts){
            //     this.newRulesRow.push(JSON.parse(JSON.stringify(netAmou)))

            // }
            this.dialogAddOrEditRow = true;
        }
        this.index = index;
        this.tableIndex = tableIndex;
    }

    editTotal2(index, tableIndex = 0) {
        const rowToEdit = this.OA_Tables[tableIndex].rows[index];
        this.edit = true;
        this.dialogAddTotal = true;
        this.newNameRow = rowToEdit.title;
        this.newDisplaySignRow = rowToEdit.displaySign;
        this.typeOfTotal = rowToEdit.keys.length
            ? rowToEdit.previousAmount
                ? "previousRowsAndTotals"
                : "chooseLines"
            : "justPreviousRows";
        this.listTotauxToAdd = rowToEdit.keys ? rowToEdit.keys.slice() : [];
        this.index = index;
        this.tableIndex = tableIndex;
    }

    swapRow2(index1, index2, tableIndex = 0) {
        this.OA_Tables[tableIndex].rows[index1] = this.OA_Tables[tableIndex].rows.splice(
            index2,
            1,
            this.OA_Tables[tableIndex].rows[index1],
        )[0];
    }

    removeRow2(index, tableIndex = 0) {
        if (index >= 0 && index < this.OA_Tables[tableIndex].rows.length) {
            this.OA_Tables[tableIndex].rows.splice(index, 1);
        } else {
            debugger;
        }
    }

    displayNotStartsWith(cont) {
        cont.displayNotStartsWith = !cont.displayNotStartsWith;
        this.refreshKey++;
    }

    displayVChip(item) {
        if (/^[0-9]{6}_[a-zA-Z0-9]{32}/.test(item)) {
            const result = this.subAccountableAccounts[item];
            if (!result || !result.displayName) {
                return "";
            }
            return result.displayName + "_" + result.description;
        }
        return item;
    }

    displayDebitCreditOnlyForTab(name) {
        if (this.inRange[name] > 0 && this.inRange[name] % 1) {
            if (this.dicoDebitCredit && Object.keys(this.dicoDebitCredit).length) {
                const d = this.dicoDebitCredit[name];
                if (d.credit && !d.debit) {
                    return "Utilisé seulement au crédit";
                } else if (d.debit && !d.credit) {
                    return "Utilisé seulement au débit";
                } else {
                    debugger; /* git-ignore   should never happen */
                }
            } else {
                debugger; /* git-ignore   should never happen */
            }
        }
        return "";
    }

    validateModificatedRow() {
        // to delete V_CI
        const rowToEdit = this.OA_Tables[this.tableIndex].rows[this.index];
        rowToEdit.name = this.newNameRow;
        rowToEdit.displaySign = this.newDisplaySignRow;
        rowToEdit.columns.netAmounts = this.convertNewRulesRowIntoNetAmounts(this.newRulesRow);
        this.edit = false;
        this.index = 0;
        this.tableIndex = 0;
        this.newNameRow = "";
        this.newDisplaySignRow = -1;
        this.newRulesRow = [
            { operator: "startsWith", numbers: [], debitOrCredit: "both", notStartsWith: [] },
        ];
        this.isValid = false;
        this.dialogAddOrEditRow = false;
    }

    validateNewRow() {
        this.OA_Tables[this.tableIndex].rows.push({
            name: this.newNameRow,
            key: uuid(),
            displaySign: this.newDisplaySignRow,
            columns: { netAmounts: this.convertNewRulesRowIntoNetAmounts(this.newRulesRow) },
        });
        this.newNameRow = "";
        this.newDisplaySignRow = -1;
        this.newRulesRow = [
            { operator: "startsWith", numbers: [], debitOrCredit: "both", notStartsWith: [] },
        ];
        this.isValid = false;
        this.dialogAddOrEditRow = false;
    }

    validateModificatedTotal() {
        const rowToEdit = this.OA_Tables[this.tableIndex].rows[this.index];
        rowToEdit.title = this.newNameRow;
        rowToEdit.displaySign = this.newDisplaySignRow;
        rowToEdit.keys = this.listTotauxToAdd.slice();
        rowToEdit.previousAmount = this.typeOfTotal === "chooseLines" ? false : true;
        this.edit = false;
        this.index = 0;
        this.tableIndex = 0;
        this.newNameRow = "";
        this.newDisplaySignRow = -1;
        this.listTotauxToAdd = [];
        this.isValid2 = false;
        this.dialogAddTotal = false;
    }

    validateNewTotal() {
        this.OA_Tables[this.tableIndex].rows.push({
            title: this.newNameRow,
            displaySign: this.newDisplaySignRow,
            total: true,
            previousAmount: this.typeOfTotal === "chooseLines" ? false : true,
            keys: this.listTotauxToAdd.slice(),
            key: uuid(),
        });
        this.newNameRow = "";
        this.newDisplaySignRow = -1;
        this.listTotauxToAdd.length = 0;
        this.isValid2 = false;
        this.dialogAddTotal = false;
    }

    // @Watch("typeOfTotal")
    reinitialiseListTotaux() {
        this.listTotauxToAdd.length = 0;
    }

    validateModificatedRatio() {
        const rowToEdit = this.OA_Tables[this.tableIndex].rows[this.index];
        rowToEdit.name = this.newNameRow;
        rowToEdit.displaySign = this.newDisplaySignRow;
        rowToEdit.input.key1 = this.newKey1;
        rowToEdit.input.key2 = this.newKey2;
        rowToEdit.input.modify = this.newKeyToModify;
        rowToEdit.editable = !!this.newKeyToModify;
        this.edit = false;
        this.index = 0;
        this.tableIndex = 0;
        this.newNameRow = "";
        this.newDisplaySignRow = -1;
        this.newKey1 = "";
        this.newKey2 = "";
        this.isValid3 = false;
        this.dialogAddRatio = false;
    }

    validateNewRatio() {
        this.OA_Tables[this.tableIndex].rows.push({
            name: this.newNameRow,
            displaySign: this.newDisplaySignRow,
            marginRatio: true,
            key: uuid(),
            input: {
                key1: this.newKey1,
                key2: this.newKey2,
                modify: this.newKeyToModify,
            },
            editable: !!this.newKeyToModify,
        });
        this.newNameRow = "";
        this.newDisplaySignRow = -1;
        this.newKey1 = "";
        this.newKey2 = "";
        this.newKeyToModify = "key1";
        this.isValid3 = false;
        this.dialogAddRatio = false;
    }

    get clientCount() {
        return !this.allAccountingCompany ? this.scopeManager.companyScopeArrays.clients.length : 0;
    }

    async upsertOperatingAccount(isFinished: Boolean) {
        const data = JSON.parse(JSON.stringify(this.OA_Tables));
        if (this.OA_Tables?.length === 1) {
            data[0].name = this.title;
        }
        if (this.range?.length) {
            data[0].range = this.range;
        }
        const status = isFinished ? "VALIDATE" : "PENDING_VALIDATION";
        const result = await this.$apollo.mutate({
            mutation: UPSERT_OPERATING_ACCOUNT,
            variables: {
                id: this.idSheet === null ? "new" : this.idSheet,
                name: this.title,
                data: data,
                // status: isFinished ? 'VALIDATE' : 'EDITION',
                use: this.use,
                type: this.type,
                companyScopeId: this.scopeId,
            },
        });
        this.$router.push({ name: "operatingAccountTable" });
    }

    pushAdaptedCondition(adaptedRulesRow, condition) {
        if (condition.operator === "equalTo") {
            if (condition.debitOrCredit === "creditOnly") {
                adaptedRulesRow.push({ startsWith: condition.numbers, creditOnly: true });
            } else if (condition.debitOrCredit === "debitOnly") {
                adaptedRulesRow.push({ startsWith: condition.numbers, debitOnly: true });
            } else {
                adaptedRulesRow.push({ startsWith: condition.numbers });
            }
        } else if (condition.operator === "startsWith") {
            if (condition.notStartsWith && condition.notStartsWith.length) {
                if (condition.debitOrCredit === "creditOnly") {
                    adaptedRulesRow.push({
                        startsWith: condition.numbers,
                        notStartsWith: condition.notStartsWith,
                        creditOnly: true,
                    });
                } else if (condition.debitOrCredit === "debitOnly") {
                    adaptedRulesRow.push({
                        startsWith: condition.numbers,
                        notStartsWith: condition.notStartsWith,
                        debitOnly: true,
                    });
                } else {
                    adaptedRulesRow.push({
                        startsWith: condition.numbers,
                        notStartsWith: condition.notStartsWith,
                    });
                }
            } else {
                if (condition.debitOrCredit === "creditOnly") {
                    adaptedRulesRow.push({ startsWith: condition.numbers, creditOnly: true });
                } else if (condition.debitOrCredit === "debitOnly") {
                    adaptedRulesRow.push({ startsWith: condition.numbers, debitOnly: true });
                } else {
                    adaptedRulesRow.push({ startsWith: condition.numbers });
                }
            }
        }
    }

    // validationBobby() {
    //     this.upsertOperatingAccount(true)
    // }

    // devalidationBobby() {
    //     this.upsertOperatingAccount(true)
    // }

    checkNumberAAconcerned(AA: string) {
        let compteur = 0;
        for (const aa of this.scopedAccountableAccounts) {
            if (aa.name.startsWith(AA)) {
                compteur++;
            }
        }
        return compteur;
    }

    isOverflowRange(AA: string) {
        if (this.range.length === 0) {
            return false;
        }
        let compteur = 0;
        for (const r of this.range) {
            if (!AA.startsWith(r)) {
                compteur++;
            }
        }
        if (compteur === this.range.length) {
            return true;
        }
        return false;
    }

    isDoublon(AA: string) {
        if (this.doublons.length === 0) {
            return false;
        }
        for (const doublon of this.doublons) {
            if (doublon.startsWith(AA)) {
                return true;
            }
        }
        return false;
    }

    integrationAACheckedIntoRulesRows(nameRow) {
        const row = this.rulesRows.find((e) => e.name === nameRow);
        if (row.netAmounts && row.netAmounts.length) {
            for (const netAmount of row.netAmounts) {
                if (netAmount.operator === "equalTo") {
                    netAmount.numbers = netAmount.numbers.concat(this.selectionTab);
                    this.selectionTab.length = 0;
                }
            }
            if (this.selectionTab.length !== 0) {
                row.netAmounts.push({
                    operator: "equalTo",
                    numbers: this.selectionTab,
                    debitOrCredit: "both",
                    notStartsWith: [],
                });
            }
        } else {
            debugger;
        }
        this.dialogFromTab = false;
    }

    duplicate() {
        this.$router.push({ name: "new-operatingAccountSheet", replace: true });
        this.scopeId = null;
        this.importSuccess = false;
        this.allAccountingCompany = false;
        this.importSuccess = true;
        this.readOnly = false;
        this.title += "*";
    }

    addIntermediaireBalance(item) {
        const itemCopy = JSON.parse(JSON.stringify(item));
        if (itemCopy.netAmountAA) {
            if (itemCopy.netAmountAA.OR) {
                itemCopy.columns = { netAmounts: itemCopy.netAmountAA.OR };
            } else {
                itemCopy.columns = { netAmounts: [{ startsWith: itemCopy.netAmountAA }] };
            }
            delete itemCopy.netAmountAA;
        }

        this.OA_Tables[0].rows.push(itemCopy);
        this.dialogChooseSig = false;
    }

    get onlyUsedAccountableAccounts() {
        return this.use === "CASH_FLOW_PLAN" && this.clientCount === 1;
    }

    get disabledTable() {
        if (this.onlyUsedAccountableAccounts) {
            return false;
        }
        return !this.range.length;
    }

    get maxHeight() {
        const innHeight = window.innerHeight;
        const vhHeight = (330 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    // flag to change
    convertNewRulesRowIntoNetAmounts(newRulesRow) {
        // to delete V_CI
        const result = [];
        for (const rule of newRulesRow) {
            this.pushAdaptedCondition(result, rule);
        }
        return result;
    }

    convertNetAmountsIntoNewRulesRow(conditions) {
        // to delete V_CI
        const adaptedNetAmounts = [];
        for (const condition of conditions)
            if (condition.notStartsWith && condition.notStartsWith.length) {
                if (condition.creditOnly) {
                    adaptedNetAmounts.push({
                        operator: "startsWith",
                        numbers: condition.startsWith,
                        debitOrCredit: "creditOnly",
                        notStartsWith: condition.notStartsWith,
                    });
                } else if (condition.debitOnly) {
                    adaptedNetAmounts.push({
                        operator: "startsWith",
                        numbers: condition.startsWith,
                        debitOrCredit: "debitOnly",
                        notStartsWith: condition.notStartsWith,
                    });
                } else {
                    adaptedNetAmounts.push({
                        operator: "startsWith",
                        numbers: condition.startsWith,
                        debitOrCredit: "both",
                        notStartsWith: condition.notStartsWith,
                    });
                }
            } else {
                if (condition.creditOnly) {
                    adaptedNetAmounts.push({
                        operator: "startsWith",
                        numbers: condition.startsWith,
                        debitOrCredit: "creditOnly",
                        notStartsWith: [],
                    });
                } else if (condition.debitOnly) {
                    adaptedNetAmounts.push({
                        operator: "startsWith",
                        numbers: condition.startsWith,
                        debitOrCredit: "debitOnly",
                        notStartsWith: [],
                    });
                } else {
                    adaptedNetAmounts.push({
                        operator: "startsWith",
                        numbers: condition.startsWith,
                        debitOrCredit: "both",
                        notStartsWith: [],
                    });
                }
            }
        return adaptedNetAmounts;
    }

    deleteSubAccountableAccounts() {
        const regex = /^[0-9]{6}_[a-zA-Z0-9]{32}/;
        for (const table of this.OA_Tables) {
            for (const row of table.rows) {
                for (const col of this.tableColumns(table)) {
                    if (row.columns) {
                        for (const item of row.columns[col.value]) {
                            if (item.startsWith && item.startsWith.some((e) => e.match(regex))) {
                                item.startsWith = item.startsWith.filter((e) => !e.match(regex));
                            }
                            if (
                                item.notStartsWith &&
                                item.notStartsWith.some((e) => e.match(regex))
                            ) {
                                item.notStartsWith = item.notStartsWith.filter(
                                    (e) => !e.match(regex),
                                );
                            }
                        }
                    }
                }
            }
        }
    }
}

export default toNative(OperatingAccountSheet);
</script>

<style>
.sticky-card {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 5;
}
</style>
